import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Plus } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { DropZone } from '../DropZone/DropZone'
import { AiUploadedFile } from './AiUploadedFile'
export interface AiFileUploadPanelProps {
  files: File[]
  handleDrop: (acceptedFiles: File[]) => void
  handleRemovePendingFile: (index: number) => () => void
}

export const AiFileUploadPanel = ({ files, handleDrop, handleRemovePendingFile }: AiFileUploadPanelProps) => {
  // NOTE: 目前僅開放單檔案上傳
  const hasFiles = files.length > 0

  return (
    <Box flex={1} display="flex" flexDirection="column">
      <Box py={4}>
        <Text variant="body" color={colors.grey600}>檔案辨識功能目前只支援 PDF 檔案格式</Text>
      </Box>
      {hasFiles
        ? (
          <VStack alignItems="center" flexWrap="wrap" gap={3}>
            {files.map((file, index) => (
              <AiUploadedFile
                key={index}
                fileName={file.name}
                fileSize={file.size}
                onRemove={handleRemovePendingFile(index)}
              />
            ))}
          </VStack>
        )
        : (
          <DropZone
            onDrop={handleDrop}
            rootProps={{ height: '100%' }}
            displayText={(
              <VStack alignItems="center" gap="10px">
                <Text align="center">
                  加入檔案到此處
                  <br />
                  才能進行文字辨識，進行商品配對
                </Text>
                <Button startIcon={<Plus />} variant="outlined" color="blue" width="106px">
                  增加來源
                </Button>
              </VStack>
            )}
            accept={['.pdf']}
          />
        )}
    </Box>
  )
}
